module.exports = __webpack_public_path__ + "static/orangecreamsoda-a19b71ca2e544da60b66ff16a22536c2.jpg";